module.exports = __webpack_public_path__ + "static/media/Unirac_Logo_Blue.ecce3529.png";